
const ApplyNow = () => {
  return (
    <section className="w-full py-12 md:py-20 px-6">
      <div className="max-w-6xl mx-auto rounded-[32px] md:rounded-[48px] bg-[#0A0F1C] p-8 md:p-16 lg:p-20 text-center relative overflow-hidden shadow-2xl border border-white/5">
        {/* Subtle Background Glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[var(--primary)] opacity-[0.03] rounded-full blur-[120px] pointer-events-none" />

        {/* Heading */}
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-serif text-white mb-6 md:mb-8 leading-[1.2] font-bold max-w-4xl mx-auto relative ">
          Apply now and get money in your account today
        </h2>

        {/* Description */}
        <p className="text-gray-400 text-sm md:text-base lg:text-lg mb-10 md:mb-12 font-sans max-w-2xl mx-auto opacity-70 leading-relaxed relative ">
          Join over 1.2M verified users who trust ToofanLoan for their short-term credit requirements.
        </p>

        {/* Button Container */}
        <div className="mb-12 md:mb-16 relative">
          <a
            href={import.meta.env.VITE_WEBSITE_LINK}
            target="_blank"
            className="inline-block px-10 md:px-14 py-4 md:py-5 bg-[var(--primary)] text-white font-bold text-sm md:text-base uppercase tracking-[0.1em] rounded-xl shadow-[0_0_40px_rgba(4,139,225,0.25)] hover:scale-105 hover:shadow-[0_0_50px_rgba(4,139,225,0.4)] active:scale-95 transition-all duration-300"
          >
            START YOUR APPLICATION NOW
          </a>
        </div>

        {/* Footer info labels */}
        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-[10px] md:text-xs font-bold text-gray-500 tracking-[0.2em] uppercase relative ">
          <span>NO HIDDEN COSTS</span>
          <span className="text-gray-800 opacity-40">•</span>
          <span>RBI REGULATED</span>
          <span className="text-gray-800 opacity-40">•</span>
          <span>SECURE LINK</span>
        </div>
      </div>
    </section>
  );
};

export default ApplyNow;
